import {StyleSheet} from 'react-native';

import {black, grey80, greyf7, white} from '/theme/color/on.color';

export const styles = StyleSheet.create({
  container: {
    flex: 1,
    padding: 24,
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: white,
  },
  UnwishList: {
    width: 20,
    height: 20,
    marginBottom: 16,
  },
  title: {
    fontSize: 20,
    color: black,
    marginBottom: 8,
  },
  titlePaddingBottom: {
    paddingBottom: 14,
  },
  description: {
    fontSize: 14,
    color: black,
    textAlign: 'center',
    marginBottom: 4,
  },
  descriptionPaddingBottom: {
    paddingBottom: 14,
  },
  previewBox: {
    marginTop: 24,
    width: '100%',
    backgroundColor: greyf7,
    borderRadius: 8,
    padding: 12,
  },
  previewLabel: {
    fontSize: 16,
    color: grey80,
    marginBottom: 8,
    textAlign: 'center',
    alignSelf: 'center',
  },
  previewItem: {
    flexDirection: 'row',
    alignItems: 'center',
    backgroundColor: white,
    padding: 12,
    borderRadius: 8,
  },
  avatarPlaceholder: {
    width: 36,
    height: 36,
    borderRadius: 18,
    backgroundColor: greyf7,
    marginRight: 12,
  },
  textContainer: {
    flex: 1,
  },
  coachName: {
    fontSize: 14,
    color: black,
  },
  coachRank: {
    fontSize: 12,
    color: grey80,
  },
  starIcon: {
    tintColor: grey80,
    fontSize: 60,
    paddingBottom: 12,
  },
});
